<template>
  <div class="header-container">
    <header class="header">
      <i class="header__logo">
        <img
          class="u-margin-bottom-medium"
          src="../assets/IMAGES/JMC-LOGO-BLACK.png"
          alt="VB Logo"
        />
      </i>
    </header>
  </div>
</template>

<script>
export default {
  name: "Header",
};
</script>

<style lang="scss">
.header {
  padding-top: calc(929 / 1828 * 100%);
  height: 0;
  min-width: 100%;
  background-image: url("../assets/IMAGES/JMC_header-DT.jpg");
  background-size: contain;
  background-attachment: fixed;
  background-position: top;
  background-repeat: no-repeat;
  background-color: $color-white;
  position: relative;

  &-container {
    width: 100%;
    height: 100%;
    display: block;
  }

  @include respond(tab-port) {
    height: 100vh;
    width: auto;
    min-width: auto;
    background-image: url("../assets/IMAGES/JMC_header_ipad.jpg");
    background-size: cover;
    background-attachment: scroll;
    background-position: center;
    background-repeat: no-repeat;
    background-color: $color-black;
    max-height: auto;
    max-width: 100%;
  }

  @include respond(phone) {
    background-image: url("../assets/IMAGES/JMC_header_iphone.jpg");
  }

  &__logo-box {
    position: absolute;
  }

  &__logo {
    img {
      position: absolute;
      width: 20vw;
      top: 10%;
      left: 50%;
      transform: translate(-50%, -50%);
      -webkit-animation: invertFadeIn 0.5s ease-in-out;
      animation: invertFadeIn 0.5s ease-in-out;
      -ms-animation: invertFadeIn 0.5s ease-in-out;
      -moz-animation: invertFadeIn 0.5s ease-in-out;
      animation-delay: 0.5s;
      animation-fill-mode: backwards;

      @include respond(tab-port) {
        top: 10%;
        width: 75vw;
      }
    }
  }

  &__text-box {
    position: absolute;
    top: 80vh;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    width: 80vw;
    z-index: 1;
  }
}
</style>
